import { CampaignModel } from '../types/campaign.interface';
import { BusinessRuleType, EntityDefinition } from '../types/entity-definition.interface';

export const campaignModelDefinition: EntityDefinition<CampaignModel> = {
  entityType: 'CampaignModel',
  i18nBase: 'entities.campaign.models',
  list: {
    columns: [{ field: 'name', headerKey: 'common.labels.name', sortable: true, filterable: true }],
  },
  fields: [
    { field: 'name', labelKey: 'common.labels.name', required: true, type: 'text', minLength: 3, maxLength: 100 },
    { field: 'campaignId', labelKey: 'entities.campaign.singular', type: 'hidden', required: true },
  ],
  validationRules: [
    {
      type: BusinessRuleType.CREATE_VALIDATION,
      rule: (entity: CampaignModel, store) => {
        if (!store) return true;
        const entities = store.getData<CampaignModel>('CampaignModel')();
        return !entities.some(m => m.name.toLowerCase().trim() === entity.name.toLowerCase().trim());
      },
      errorMessageKey: 'entities.campaign.models.duplicateError',
    },
    {
      type: BusinessRuleType.EDIT_VALIDATION,
      rule: (entity: CampaignModel, store) => {
        if (!store) return true;
        const entities = store.getData<CampaignModel>('CampaignModel')();
        return !entities.some(m => m.name.toLowerCase().trim() === entity.name.toLowerCase().trim() && m.id !== entity.id);
      },
      errorMessageKey: 'entities.campaign.models.duplicateError',
    },
  ],
  actionButtons: {
    parent: {
      add: true,
      edit: true,
    },
  },
  formOptions: {
    showDeleteButton: true,
  },
  messages: {
    dialogTitles: {
      create: () => 'entities.campaign.models.createTitle',
      edit: () => 'entities.campaign.models.editTooltip',
      delete: () => 'common.confirmations.deleteTitleWithName',
    },
    buttons: {
      add: () => 'common.buttons.add',
      create: () => 'common.buttons.add',
      edit: () => 'common.buttons.edit',
      delete: () => 'common.buttons.delete',
    },
    confirmDelete: () => 'entities.campaign.models.deleteConfirm',
  },
};
